import { Injectable } from '@angular/core';

import type {
  PolicyList,
  UnassociatedRiskDetailSuccess
} from '@amfam/shared/models/lib/billing/bill-account.model';

import { Adapter } from './adapter';

@Injectable({
  providedIn: 'root'
})
export class UnassociatedRiskAdapterService implements Adapter<PolicyList> {
  constructor() {}

  adapt(response: UnassociatedRiskDetailSuccess, policyList: PolicyList = []): PolicyList {
    if (response.policies?.length) {
      const policyListItems: PolicyList = [];
      response.policies.forEach(policy => {
        const policyObj = policyList.find(
          policyFrmBilling => policyFrmBilling.policyNumber === policy.policyNumber
        );
        if (policyObj) {
          policyListItems.push({
            ...policyObj,
            riskDescriptionList: policy.riskDescriptions,
            policyNumber: policyObj.policyNumber,
            productType: policy.productType
          });
        }
      });
      return policyListItems.length === 0 ? policyList : policyListItems;
    }
    return policyList;
  }
}
